import {Fill, Stroke, Style} from 'ol/style';
import {Vector as VectorLayer} from 'ol/layer';
import VectorSource from 'ol/source/Vector';
import TopoJSON from 'ol/format/TopoJSON';
import {Text} from 'ol/style';
import React from 'react';
import {getAccessibleState} from '../../../Essentials/common_fn';  
/**
 * India Level Data
 * @param {*} feature 
 * @returns 
 */
 
 ////////////////nikhil/////////////////
// class App extends React.Component{
//   constructor(props){
//     super(props);
//     this.state={apiResponse:""};
//   }
//   callAPI(){
//     fetch("http://localhost:9000/getboundary/up")
//     .then(res=>res.text())
//     .then(res=>this.setState({apiResponse:res}));
//    } 
//    componentDidMount(){
//     this.callAPI();
//    }
// }
// console.log(this.state.apiResponse);
 ///////////////////////////////////////
  export const stateBoundaryVectorSource = new VectorSource({
    url: 'india-state-boundary.json',
    // url:this.state.apiResponse,
    format: new TopoJSON({
      layers: ['admin_boundary'],
    }),
    overlaps: true,
  });

 

  export  function stateBoundaryStyle(optionSelection){
    return function (feature) {
    let states = getAccessibleState(optionSelection);
    if(states.includes(feature.get('STATE_NAME')) || states === 'ALL'){
    return new Style({
      // fill: new Fill({
      //   color: color,
      // }),
      text: new Text({
        text: feature.get('STATE_NAME'),
        font: 'bold 12px Arial',
      }),
      stroke: new Stroke({
        color: 'rgba(1, 0, 0, 1)',
        width: 0.5,
        //lineDash: [1,2],
      }),
      fill : new Fill({
        color: 'rgba(0,0,0,0.01)',
    })
    });
  }else{
    return null;
  }
  }};